// Hot Tub Defense Sprite Constants
// All sprite keys and file paths

export const BEAR_SPRITES = {
  HONEY: 'bear-honey',
  SALMON: 'bear-salmon', 
  BARRACUDA: 'bear-barracuda',
  BARRACUDA_T2: 'bear-barracuda-t2',
  BARRACUDA_T3: 'bear-barracuda-t3',
  BASS: 'bear-bass',
  PUFFERFISH: 'bear-pufferfish',
  SWORDFISH: 'bear-swordfish',
  EEL: 'bear-eel',
  CATFISH: 'bear-catfish',
  SHARK: 'bear-shark',
  BLOBFISH: 'bear-blobfish',
} as const

export const TUB_SPRITES = {
  HONEY: 'tub-honey',
  SALMON: 'tub-salmon',
  BARRACUDA: 'tub-barracuda',
  BARRACUDA_T2: 'tub-barracuda-t2',
  BARRACUDA_T3: 'tub-barracuda-t3',
  BASS: 'tub-bass', 
  PUFFERFISH: 'tub-pufferfish',
  SWORDFISH: 'tub-swordfish',
  EEL: 'tub-eel',
  CATFISH: 'tub-catfish',
  SHARK: 'tub-shark',
  BLOBFISH: 'tub-blobfish',
} as const

// Bear throwing sprites
export const BEAR_THROW_SPRITES = {
  HONEY: 'bear-throw-honey',
  SALMON: 'bear-throw-salmon',
  BARRACUDA: 'bear-throw-barracuda',
  BARRACUDA_T2: 'bear-throw-barracuda-t2',
  BARRACUDA_T3: 'bear-throw-barracuda-t3',
  BASS: 'bear-throw-bass',
  PUFFERFISH: 'bear-throw-pufferfish',
  SWORDFISH: 'bear-throw-swordfish',
  EEL: 'bear-throw-eel',
  CATFISH: 'bear-throw-catfish',
  SHARK: 'bear-throw-shark',
  BLOBFISH: 'bear-throw-blobfish',
} as const

// Enemy sprites
export const ENEMY_SPRITES = {
  BASIC: 'snowman-basic',
  FAST: 'snowman-fast',
  TANK: 'snowman-tank',
  BOSS: 'snowman-boss',
} as const

// Environment sprites
export const ENVIRONMENT_SPRITES = {
  LODGE: 'lodge',
  TREE_1: 'tree-1',
  TREE_2: 'tree-2',
  TREE_3: 'tree-3',
} as const

// Animation sprites for Chunk 5: Fish + Water Animations
export const ANIMATION_SPRITES = {
  STEAM: 'steam',
  RIPPLE: 'ripple',
} as const

// Explosion sprites for Chunk 6: Enemy Animations + Effects
export const EXPLOSION_SPRITES = {
  FIRE: 'explosion-fire',
  ICE: 'explosion-ice', 
  ELECTRIC: 'explosion-electric',
} as const

// Projectile sprites for Chunk 7: Projectile Sprites + Bass Rider
export const PROJECTILE_SPRITES = {
  HONEY: 'proj-honey',
  SALMON: 'proj-salmon',
  BASS: 'proj-bass',
  PUFFERFISH: 'proj-pufferfish',
  SWORDFISH: 'proj-swordfish',
  EEL: 'proj-eel',
  CATFISH: 'proj-catfish', 
  SHARK: 'proj-shark',
  BARRACUDA: 'proj-barracuda',
  BARRACUDA_T2: 'proj-barracuda-t2',
  BARRACUDA_T3: 'proj-barracuda-t3',
  BLOBFISH: 'proj-blobfish',
  BASS_RIDER: 'bass-rider',
} as const

// Tower type mapping to sprite keys
export const TOWER_SPRITES = {
  honey: { bear: BEAR_SPRITES.HONEY, tub: TUB_SPRITES.HONEY, throw: BEAR_THROW_SPRITES.HONEY },
  salmon: { bear: BEAR_SPRITES.SALMON, tub: TUB_SPRITES.SALMON, throw: BEAR_THROW_SPRITES.SALMON },
  barracuda: { bear: BEAR_SPRITES.BARRACUDA, tub: TUB_SPRITES.BARRACUDA, throw: BEAR_THROW_SPRITES.BARRACUDA },
  bass: { bear: BEAR_SPRITES.BASS, tub: TUB_SPRITES.BASS, throw: BEAR_THROW_SPRITES.BASS },
  pufferfish: { bear: BEAR_SPRITES.PUFFERFISH, tub: TUB_SPRITES.PUFFERFISH, throw: BEAR_THROW_SPRITES.PUFFERFISH },
  swordfish: { bear: BEAR_SPRITES.SWORDFISH, tub: TUB_SPRITES.SWORDFISH, throw: BEAR_THROW_SPRITES.SWORDFISH },
  eel: { bear: BEAR_SPRITES.EEL, tub: TUB_SPRITES.EEL, throw: BEAR_THROW_SPRITES.EEL },
  catfish: { bear: BEAR_SPRITES.CATFISH, tub: TUB_SPRITES.CATFISH, throw: BEAR_THROW_SPRITES.CATFISH },
  shark: { bear: BEAR_SPRITES.SHARK, tub: TUB_SPRITES.SHARK, throw: BEAR_THROW_SPRITES.SHARK },
  blobfish: { bear: BEAR_SPRITES.BLOBFISH, tub: TUB_SPRITES.BLOBFISH, throw: BEAR_THROW_SPRITES.BLOBFISH },
} as const

// All sprite files that need to be loaded
export const SPRITE_MANIFEST = [
  // Bear sprites
  { key: BEAR_SPRITES.HONEY, path: 'sprites/bear-honey.png' },
  { key: BEAR_SPRITES.SALMON, path: 'sprites/bear-salmon.png' },
  { key: BEAR_SPRITES.BARRACUDA, path: 'sprites/bear-barracuda.png' },
  { key: BEAR_SPRITES.BARRACUDA_T2, path: 'sprites/bear-barracuda-t2.png' },
  { key: BEAR_SPRITES.BARRACUDA_T3, path: 'sprites/bear-barracuda-t3.png' },
  { key: BEAR_SPRITES.BASS, path: 'sprites/bear-bass.png' },
  { key: BEAR_SPRITES.PUFFERFISH, path: 'sprites/bear-pufferfish.png' },
  { key: BEAR_SPRITES.SWORDFISH, path: 'sprites/bear-swordfish.png' },
  { key: BEAR_SPRITES.EEL, path: 'sprites/bear-eel.png' },
  { key: BEAR_SPRITES.CATFISH, path: 'sprites/bear-catfish.png' },
  { key: BEAR_SPRITES.SHARK, path: 'sprites/bear-shark.png' },
  { key: BEAR_SPRITES.BLOBFISH, path: 'sprites/bear-blobfish.png' },
  
  // Bear throwing sprites
  { key: BEAR_THROW_SPRITES.HONEY, path: 'sprites/bear-throw-honey.png' },
  { key: BEAR_THROW_SPRITES.SALMON, path: 'sprites/bear-throw-salmon.png' },
  { key: BEAR_THROW_SPRITES.BARRACUDA, path: 'sprites/bear-throw-barracuda.png' },
  { key: BEAR_THROW_SPRITES.BARRACUDA_T2, path: 'sprites/bear-throw-barracuda-t2.png' },
  { key: BEAR_THROW_SPRITES.BARRACUDA_T3, path: 'sprites/bear-throw-barracuda-t3.png' },
  { key: BEAR_THROW_SPRITES.BASS, path: 'sprites/bear-throw-bass.png' },
  { key: BEAR_THROW_SPRITES.PUFFERFISH, path: 'sprites/bear-throw-pufferfish.png' },
  { key: BEAR_THROW_SPRITES.SWORDFISH, path: 'sprites/bear-throw-swordfish.png' },
  { key: BEAR_THROW_SPRITES.EEL, path: 'sprites/bear-throw-eel.png' },
  { key: BEAR_THROW_SPRITES.CATFISH, path: 'sprites/bear-throw-catfish.png' },
  { key: BEAR_THROW_SPRITES.SHARK, path: 'sprites/bear-throw-shark.png' },
  { key: BEAR_THROW_SPRITES.BLOBFISH, path: 'sprites/bear-throw-blobfish.png' },
  
  // Tub sprites  
  { key: TUB_SPRITES.HONEY, path: 'sprites/tub-honey.png' },
  { key: TUB_SPRITES.SALMON, path: 'sprites/tub-salmon.png' },
  { key: TUB_SPRITES.BARRACUDA, path: 'sprites/tub-barracuda.png' },
  { key: TUB_SPRITES.BARRACUDA_T2, path: 'sprites/tub-barracuda-t2.png' },
  { key: TUB_SPRITES.BARRACUDA_T3, path: 'sprites/tub-barracuda-t3.png' },
  { key: TUB_SPRITES.BASS, path: 'sprites/tub-bass.png' },
  { key: TUB_SPRITES.PUFFERFISH, path: 'sprites/tub-pufferfish.png' },
  { key: TUB_SPRITES.SWORDFISH, path: 'sprites/tub-swordfish.png' },
  { key: TUB_SPRITES.EEL, path: 'sprites/tub-eel.png' },
  { key: TUB_SPRITES.CATFISH, path: 'sprites/tub-catfish.png' },
  { key: TUB_SPRITES.SHARK, path: 'sprites/tub-shark.png' },
  { key: TUB_SPRITES.BLOBFISH, path: 'sprites/tub-blobfish.png' },
  
  // Enemy sprites
  { key: ENEMY_SPRITES.BASIC, path: 'sprites/snowman-basic.png' },
  { key: ENEMY_SPRITES.FAST, path: 'sprites/snowman-fast.png' },
  { key: ENEMY_SPRITES.TANK, path: 'sprites/snowman-tank.png' },
  { key: ENEMY_SPRITES.BOSS, path: 'sprites/snowman-boss.png' },
  
  // Environment sprites
  { key: ENVIRONMENT_SPRITES.LODGE, path: 'sprites/lodge.png' },
  { key: ENVIRONMENT_SPRITES.TREE_1, path: 'sprites/tree-1.png' },
  { key: ENVIRONMENT_SPRITES.TREE_2, path: 'sprites/tree-2.png' },
  { key: ENVIRONMENT_SPRITES.TREE_3, path: 'sprites/tree-3.png' },
  
  // Animation sprites (Chunk 5)
  { key: ANIMATION_SPRITES.STEAM, path: 'sprites/steam.png' },
  { key: ANIMATION_SPRITES.RIPPLE, path: 'sprites/ripple.png' },
  
  // Explosion sprites (Chunk 6) - will be created
  { key: EXPLOSION_SPRITES.FIRE, path: 'sprites/explosion-fire.png' },
  { key: EXPLOSION_SPRITES.ICE, path: 'sprites/explosion-ice.png' },
  { key: EXPLOSION_SPRITES.ELECTRIC, path: 'sprites/explosion-electric.png' },
  
  // Projectile sprites (Chunk 7) - will be created
  { key: PROJECTILE_SPRITES.HONEY, path: 'sprites/proj-honey.png' },
  { key: PROJECTILE_SPRITES.SALMON, path: 'sprites/proj-salmon.png' },
  { key: PROJECTILE_SPRITES.BASS, path: 'sprites/proj-bass.png' },
  { key: PROJECTILE_SPRITES.PUFFERFISH, path: 'sprites/proj-pufferfish.png' },
  { key: PROJECTILE_SPRITES.SWORDFISH, path: 'sprites/proj-swordfish.png' },
  { key: PROJECTILE_SPRITES.EEL, path: 'sprites/proj-eel.png' },
  { key: PROJECTILE_SPRITES.CATFISH, path: 'sprites/proj-catfish.png' },
  { key: PROJECTILE_SPRITES.SHARK, path: 'sprites/proj-shark.png' },
  { key: PROJECTILE_SPRITES.BARRACUDA, path: 'sprites/proj-barracuda.png' },
  { key: PROJECTILE_SPRITES.BARRACUDA_T2, path: 'sprites/proj-barracuda-t2.png' },
  { key: PROJECTILE_SPRITES.BARRACUDA_T3, path: 'sprites/proj-barracuda-t3.png' },
  { key: PROJECTILE_SPRITES.BLOBFISH, path: 'sprites/proj-blobfish.png' },
  { key: PROJECTILE_SPRITES.BASS_RIDER, path: 'sprites/bass-rider.png' },
] as const

// Normalized tub scales — all render ~90px wide (matching honey as reference)
// Formula: 90 / actualWidth
export const TUB_SCALES: Record<string, number> = {
  honey: 0.15,      // 601px → 90px
  salmon: 0.087,     // 1034px → 90px
  barracuda: 0.106,   // 848px → 90px
  bass: 0.091,       // 988px → 90px
  pufferfish: 0.118, // 764px → 90px
  swordfish: 0.111,  // 812px → 90px
  eel: 0.048,        // 1888px → 90px
  catfish: 0.153,    // 588px → 90px
  shark: 0.085,      // 1060px → 90px
  blobfish: 0.091,   // 988px → 90px
}

// Tiered sprites for towers that evolve on upgrade
// Tier thresholds: 0-2 upgrades = tier 1, 3-5 = tier 2, 6-9 = tier 3
export const TIERED_SPRITES: Record<string, { bear: string; tub: string; throw: string; proj: string }[]> = {
  barracuda: [
    { bear: BEAR_SPRITES.BARRACUDA, tub: TUB_SPRITES.BARRACUDA, throw: BEAR_THROW_SPRITES.BARRACUDA, proj: PROJECTILE_SPRITES.BARRACUDA },
    { bear: BEAR_SPRITES.BARRACUDA_T2, tub: TUB_SPRITES.BARRACUDA_T2, throw: BEAR_THROW_SPRITES.BARRACUDA_T2, proj: PROJECTILE_SPRITES.BARRACUDA_T2 },
    { bear: BEAR_SPRITES.BARRACUDA_T3, tub: TUB_SPRITES.BARRACUDA_T3, throw: BEAR_THROW_SPRITES.BARRACUDA_T3, proj: PROJECTILE_SPRITES.BARRACUDA_T3 },
  ],
}

export function getTierIndex(totalUpgrades: number): number {
  if (totalUpgrades >= 6) return 2
  if (totalUpgrades >= 3) return 1
  return 0
}

export type TowerType = keyof typeof TOWER_SPRITES
export type BearSprite = typeof BEAR_SPRITES[keyof typeof BEAR_SPRITES]  
export type TubSprite = typeof TUB_SPRITES[keyof typeof TUB_SPRITES]